import { FC } from 'react'
import { Box, Dialog, Grid, IconButton, Typography, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { PRIMARY_YELLOW, PURE_BLACK } from 'utils/customizedTheme'

interface IProps {
  title: string
  open: any
  onClose?: any
  children: any
  popupWidth: string
  popupPadding?: number
  fullScreen?: boolean
}

const DialogPopup: FC<IProps> = ({ title, open, children, popupWidth, popupPadding=10, fullScreen = false, onClose = () => {}}) => {
 
  const theme = useTheme()

  return (
  <Dialog
    onClose={onClose}
    open={open}
    fullScreen={fullScreen}
    maxWidth={fullScreen ? false : 'xl'}
    PaperProps={{
      sx: {
        margin: 0,
        padding: 0,
        width: fullScreen ? '100vw !important' : popupWidth,
        height: fullScreen ? '100vh !important' : 'auto',
        maxWidth: fullScreen ? '100vw !important' : { xs: 'calc(100vw - 40px)', md: '80vw' },
        background: theme.palette.background.default,
      },
    }}
  >
    <Typography
          component='h2'
          sx={{
            textAlign: 'center',
            fontWeight: '600',
            fontSize: '1.7rem',
            fontFamily: 'Newsreader',
            color: PURE_BLACK,
            padding: '10px',
            backgroundColor: PRIMARY_YELLOW,
            position: 'relative',
          }}
        >
          {`${title}`}
          <IconButton
            onClick={onClose}
            aria-label='close'
            sx={{
              color: PURE_BLACK,
              position: 'absolute',
              top: '0px',
              right: '0px',
            }}
          >
            <CloseIcon sx={{ fontSize: '2rem' }} />
          </IconButton>
        </Typography>

        <Box sx={{ margin: `${popupPadding}px` }}>
         {children}      
        </Box>
       
  </Dialog>
  )
}

export default DialogPopup
